import * as React from 'react';
import { Responsive } from '@cian/ui-kit';
import { About as AboutComponent, AboutTitle } from '../../components/AboutRedesigned';
import { useSelector } from 'react-redux';
import { getDeveloperDescription } from '../../selectors/developerV2';
import { DeveloperDescription } from '../../components/DeveloperDescription';
import { ReliabilityContainer } from '../ReliabilityContainer';
import { Regions } from '../Regions';

export function AboutRedesigned() {
  const description = useSelector(getDeveloperDescription);

  return (
    <AboutComponent
      title={<AboutTitle />}
      description={<DeveloperDescription description={description} />}
      regions={<Regions />}
      reliable={
        <Responsive desktop>
          <ReliabilityContainer />
        </Responsive>
      }
    />
  );
}
